// Store
import useProfileStore from '../../../store/profileStore.js';

// Hooks
import { useAppTheme } from '../../../hooks/useAppTheme.js';

// Components
import { Grid, TextField } from "@mui/material";
import { PersonOutline, EmailOutlined, PhoneOutlined, CakeOutlined } from '@mui/icons-material';

// Style
import { orange } from '@mui/material/colors/index.js';
import { darkTheme } from '../../../styles/colorSchemes/index.js';

// Other
import { capitalizeString, formatDate3 } from '../../../utils/index.js';

function Formular() {
	const { profile, setProfile } = useProfileStore();
	const { isDarkMode } = useAppTheme();

	const onChangeFirstName = (event) => {
		if (/\d/.test(event.target.value)) 
			return;

		const p = { ...profile };
		p.firstName = capitalizeString(event.target.value);
		setProfile(p);
	};

	const onChangeLastName = (event) => {
		if (/\d/.test(event.target.value)) 
			return;

		const p = { ...profile };
		p.lastName = capitalizeString(event.target.value);
		setProfile(p);
	};

	const onChangeDateOfBirth = (event) => {
		if (event.target.value.length > 10) 
			return;

		const p = { ...profile };
		p.dateOfBirth = event.target.value;
		setProfile(p);
	};

	const onChangeTelephone = (event) => {
		const p = { ...profile };
		p.telephone = event.target.value;
		setProfile(p);
	};

	const primaryColor = isDarkMode ? orange[500] : '#1976d2';

	// Common dark mode field styling
	const getFieldSx = (isDisabled = false) => ({
		'& .MuiOutlinedInput-root': {
			borderRadius: 2,
			bgcolor: isDarkMode 
				? (isDisabled ? 'rgba(255, 255, 255, 0.05)' : darkTheme.headerBg)
				: (isDisabled ? 'rgba(0, 0, 0, 0.02)' : undefined),
			'& fieldset': {
				borderColor: isDarkMode ? darkTheme.cardBorder : undefined,
			},
			'&:hover fieldset': {
				borderColor: isDisabled ? undefined : primaryColor,
			},
			'&.Mui-focused fieldset': {
				borderColor: primaryColor,
			}
		},
		'& .MuiInputLabel-root': {
			color: isDarkMode ? darkTheme.textSecondary : undefined,
			'&.Mui-focused': {
				color: primaryColor,
			}
		},
		'& .MuiInputBase-input': {
			color: isDarkMode ? darkTheme.textPrimary : undefined,
			WebkitTextFillColor: isDarkMode && isDisabled ? darkTheme.textSecondary : undefined,
			opacity: isDarkMode && isDisabled ? 1 : undefined,
			// Date picker icon color
			'&::-webkit-calendar-picker-indicator': {
				filter: isDarkMode ? 'invert(1)' : undefined,
			}
		}
	});

	return (
		<Grid 
			container 
			spacing={3}
			sx={{
				'@media (max-width: 900px)': {
					margin: '0 !important',
					width: '100% !important',
					'& > .MuiGrid-item': {
						paddingTop: '12px !important',
						paddingLeft: '12px !important',
						'@media (max-width: 600px)': {
							marginRight: '10px',
						}
					}
				}
			}}
		>
			<Grid item xs={12} sm={6}>
				<TextField 
					fullWidth
					label="Vorname" 
					variant="outlined" 
					value={ profile.firstName } 
					onChange={ onChangeFirstName }
					InputProps={{
						startAdornment: (
							<PersonOutline sx={{ mr: 1, color: isDarkMode ? darkTheme.textSecondary : 'action.active' }} />
						),
					}}
					sx={getFieldSx()}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<TextField 
					fullWidth
					label="Nachname" 
					variant="outlined" 
					value={ profile.lastName }
					onChange={ onChangeLastName }
					InputProps={{
						startAdornment: (
							<PersonOutline sx={{ mr: 1, color: isDarkMode ? darkTheme.textSecondary : 'action.active' }} />
						),
					}}
					sx={getFieldSx()}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<TextField 
					fullWidth
					label="Geburtsdatum" 
					variant="outlined" 
					value={ formatDate3(profile.dateOfBirth) } 
					type="date"
					onChange={ onChangeDateOfBirth }
					InputProps={{
						startAdornment: (
							<CakeOutlined sx={{ mr: 1, color: isDarkMode ? darkTheme.textSecondary : 'action.active' }} />
						),
					}}
					InputLabelProps={{ shrink: true }}
					sx={getFieldSx()}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<TextField 
					fullWidth
					label="E-Mail" 
					disabled 
					variant="outlined" 
					value={ profile.email }
					InputProps={{
						startAdornment: (
							<EmailOutlined sx={{ mr: 1, color: isDarkMode ? darkTheme.textSecondary : 'action.active' }} />
						),
					}}
					sx={getFieldSx(true)}
				/>
			</Grid>

			<Grid item xs={12} sm={6}>
				<TextField 
					fullWidth
					label="Telefonnummer" 
					variant="outlined" 
					value={ profile.telephone }
					onChange={ onChangeTelephone }
					InputProps={{
						startAdornment: (
							<PhoneOutlined sx={{ mr: 1, color: isDarkMode ? darkTheme.textSecondary : 'action.active' }} />
						),
					}}
					sx={getFieldSx()}
				/>
			</Grid>
		</Grid>
	);
}

export default Formular;